import { render, staticRenderFns } from "./VariantChangesDialog.vue?vue&type=template&id=874878bc&scoped=true"
import script from "./VariantChangesDialog.vue?vue&type=script&lang=js"
export * from "./VariantChangesDialog.vue?vue&type=script&lang=js"
import style0 from "./VariantChangesDialog.vue?vue&type=style&index=0&id=874878bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874878bc",
  null
  
)

export default component.exports